class MailPlusUtil {
    formatterServerCustoms(item) {
        return {
            companyName: item.companyName,
            country: item.country,
            valueOfGoodsUSD: item.valueOfGoodsUSD,
            percentage: item.percentage,
            lasTransactionTime: item.lasTransactionTime,
        };
    }
    formatterServerEnterpriseWhatsAppMember(item) {
        return {
            accountName: item.accountName,
            whatsApp: item.whatsApp,
            avatarUrl: item.avatarUrl,
            accountId: item.accountId,
            type: 'enterprise',
        };
    }
    formatterWAServerEnterpriseWhatsAppMember(item) {
        var _a;
        return {
            accountName: item.number_nickname || '',
            whatsApp: item.number,
            avatarUrl: item.avatarUrl || '',
            accountId: item.accountId || '',
            type: 'enterprise',
            toList: ((_a = item.to_recipients) === null || _a === void 0 ? void 0 : _a.map(item => ({
                number: item.number,
                chatId: item.chatId,
                accountName: item.number_nickname || '',
                wa_avatar_url: item.wa_avatar_url || '',
            }))) || [],
        };
    }
    formatterServerEnterpriseWhatsAppToMember(item) {
        return {
            accountName: item.accountName,
            whatsApp: item.whatsApp,
            avatarUrl: item.avatarUrl,
            accountId: item.accountId,
            type: 'enterprise',
        };
    }
    formatterServerPersonalWhatsAppMember(item) {
        return {
            accountName: item.acc_nickname,
            whatsApp: item.number,
            avatarUrl: item.wa_avatar_url || item.avatar_url,
            accountId: item.acc_id,
            type: 'personal',
            toList: item.to_recipients,
        };
    }
    formatterWAServerPersonalWhatsAppMember(item, chatId) {
        var _a;
        return {
            accountName: item.accName,
            whatsApp: (_a = item.userId) === null || _a === void 0 ? void 0 : _a.split('@')[0],
            avatarUrl: item.accAvatarUrl,
            accountId: item.accId,
            type: 'personal',
            toList: [
                {
                    number: chatId === null || chatId === void 0 ? void 0 : chatId.split('@')[0],
                    wa_avatar_url: '',
                },
            ],
        };
    }
    formatterServerPersonalWhatsAppMsg(item) {
        return {
            time: item.t * 1000,
            content: item.body,
            title: item.from,
            isSelf: item.fromMe,
            type: 'personal',
            messageId: item.id,
        };
    }
    formatterServerEnterpriseWhatsAppMsg(item, from) {
        return {
            time: item.deliveryAt,
            content: item.content.text.body,
            title: item.accountName,
            isSelf: from === item.from,
            type: 'enterprise',
            messageId: item.messageId,
            seqNo: item.seqNo,
        };
    }
    formatterColleagueRelationList(item) {
        return Object.assign({ accountId: item.inner_account_id || item.account_id, email: item.relationType === 0 ? item.email : item.account_name + '@' + item.domain, name: item.relationType === 0 ? item.email : item.agent_email }, item);
    }
}
export const mailPlusUtilInstance = new MailPlusUtil();
